export default {
  'get-list': {
    method: 'post',
    url: 'p/vehicle/list'
  },
  getById: {
    method: 'get',
    url: 'p/vehicle/ID'
  },
  delete: {
    method: 'delete',
    url: 'p/vehicle'
  },
  add: {
    method: 'post',
    url: 'p/vehicle'
  },
  edit: {
    method: 'put',
    url: 'p/vehicle/ID'
  },
  select: {
    method: 'get',
    url: 'p/vehicle/find?key=KEY'
  },
  changeStatus: {
    method: 'post',
    url: 'p/vehicle/change-status'
  },
  archive: {
    method: 'delete',
    url: 'p/vehicle/archive'
  },
  restore: {
    method: 'put',
    url: 'p/vehicle/restore'
  },
  getDocuments: {
    method: 'post',
    url: '/p/vehicle/document/file/ID'
  },
  uploadDocument: {
    method: 'post',
    url: '/p/vehicle/document/upload'
  },
  updateDocument: {
    method: 'PUT',
    url: '/p/vehicle/document/file/ID'
  },
  archiveDocument: {
    method: 'delete',
    url: 'p/vehicle/document/archive'
  },
  restoreDocument: {
    method: 'put',
    url: 'p/vehicle/document/restore'
  },
  archivePlugin: {
    method: 'delete',
    url: 'p/vehicle/plugin/archive'
  },
  restorePlugin: {
    method: 'put',
    url: 'p/vehicle/plugin/restore'
  }
}
